module.exports = __webpack_public_path__ + "media/06 arduous.234efd94.mp3";